import * as React from 'react';
import { css } from 'aphrodite';
import styles from 'login-components/Common/svg/SVGStyles';

export default class CreditCardSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.box)}
        viewBox="0 0 100 100"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        focusable="false"
      >
        <g>
          <path
            className={css(styles.actionAccent)}
            d="M23.345,36.8H67.77a2.922,2.922,0,0,1,2.8,2.973V68.148a2.922,2.922,0,0,1-2.8,2.973H23.345a2.922,2.922,0,0,1-2.8-2.973V39.777A2.867,2.867,0,0,1,23.345,36.8Z"
          />
          <rect className={css(styles.action)} x="20.542" y="43.175" width="49.946" height="6.541" />
          <path
            className={css(styles.grey)}
            d="M40.164,60.527H25.469a1.129,1.129,0,0,1,0-2.257h14.7a1.129,1.129,0,0,1,0,2.257Z"
          />
          <path
            className={css(styles.grey)}
            d="M36.087,65.793H25.469a1.128,1.128,0,0,1,0-2.256H36.087a1.128,1.128,0,0,1,0,2.256Z"
          />
          <path
            className={css(styles.actionAccent)}
            fillRule="evenodd"
            d="M69.129,29.5a5.346,5.346,0,0,0-1.7-2.208l-1.1-.765,1.274-.849a5.1,5.1,0,0,0,1.7-2.293l.595-1.869.679,1.869a4.931,4.931,0,0,0,1.614,2.293l1.274.849-1.274,1.02a6.7,6.7,0,0,0-1.614,2.123l-.679,1.869Z"
          />
          <path
            className={css(styles.action)}
            fillRule="evenodd"
            d="M78.812,37.059a9.645,9.645,0,0,0-2.548-3.313l-1.7-1.1,1.954-1.274a9.193,9.193,0,0,0,2.548-3.4l.85-2.8,1.019,2.8a6.915,6.915,0,0,0,2.378,3.4l1.869,1.189L83.229,34a9.147,9.147,0,0,0-2.378,3.228l-1.019,2.8Z"
          />
        </g>
      </svg>
    );
  }
}
